import React, { Component } from 'react';
import styled from 'styled-components';
import {fonts, mediaQueries} from '../shared/config'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import CustomizedTab from './CustomizedTab'
import TabContainer from 'react-bootstrap/TabContainer'

import 'bootstrap/dist/css/bootstrap.min.css';

const Container = styled.div`
    display: flex;
    grid-template-columns: 1fr 2fr;
    height: 100vh;
    background-color: #A32929;
    @media (max-width: 700px){
      flex-direction: column;
    }
     /* flex-direction: row; */
    /* justify-content: center; */
    /* align-items: center; */
    
    /* padding: 3rem calc((100vw - 1300px) / 2); */
`
const ColumnLeft = styled.div`

  display: flex;
  justify-content: center;
  /* background: red; */
  padding: 3em ;
  /* width: 100%; */
  flex-direction: column;
  font-family: 'Staatliches', cursive;
  @media (max-width: 700px){
    padding: 20px 20px 0 20px !important;
    /* word-spacing: 0 !important;
    line-height: 0 !important; */
  }

`
const Header = styled.div`
  /* background: #A67233; */
  display: flex;  
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border: 1px;
  padding: 4em auto;
  /* width: 50%; */

  word-spacing: 999rem;
  text-transform: uppercase;
  color: white;
  
  font-size: 8vw;
  line-height: 1em;
  
  word-wrap: break-word;
  overflow-wrap: break-word;
  
  @media (max-width: 700px){
    padding-top: 40px !important;
    word-spacing: 0 !important;
    line-height: 0 !important;
  }

`
const Subheader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;     */
  /* height: 400px; */
  font-size: 4vw;
  justify-content: center;
  text-align: left;
  /* width: 30%;  */
  padding-top: 5vh;
  /* background:green; */
  line-height: 1em;
  @media (max-width: 700px){
    /* padding-top: 0.5; */
    line-height: 0.1em;
    /* color: white; */
    font-size: 25px;
    padding-bottom: 10px;
    text-align: left;
  }


`

const ColumnRight = styled.div`
  display: flex;
  /* justify-content: center; */
  /* background: blue; */
  padding: 5% 10px;
  /* width: 100%; */
  height: 100vh;
  flex-direction: column;
  @media (max-width: 700px){
    margin: 5px 20px 0 20px;
    height: 85%;
  }
`

const TabModuleContainer = styled.div`
    display: flex;
    /* position:relative; */
    flex-direction: column;
    /* justify-content: center; */
    /* align-items: center; */
    border: 1px solid black;
    width: 60vw;
    padding: 10px 20px;
    background: black;
    height: 95%;
    /* scroll-behavior: smooth;
    overflow-y: scroll; */



    @media (max-width: 700px){
    width: auto;
    height: auto;
    padding: 0 6px 6px 6px;
    flex-direction: column;
    height: 100%;
  }
    
`

const TextBox = styled.div`
    padding: 5em 5em;
    font-family: 'Cardo', serif;    
    /* display: flex;  
    justify-content: center;
    flex-direction: column;
    align-items: center; */
    @media (max-width: 700px){
    padding: 10px 15px;
    }
`

const Title = styled.div`
    font-size: 50px;
    font-family: 'Staatliches', cursive;
    @media (max-width: 700px){
    font-size: 25px;
    margin-top: 10px;
    }
`

const Image = styled.img`
    /* display: flex;  
    justify-content: center;
    flex-direction: column;
    align-items: center; */
    width: 75%;
    margin: auto;
    display: block; 

`

const Paragraph = styled.div`
    padding: 20px 0;
    @media (max-width: 700px){
    font-size: 15px;
    padding: 10px 0;
    }
`

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
  text-align: center;
  padding-right: 10px;
  color: black;
`;

function TheTippingPointTabs(props){
  return (
    <Container>
      <ColumnLeft>
      {props.data.map(block=>{
        if(block.type==="title"){
          return(
            <>
              <Header>{block.header}</Header>
              <Subheader> {block.subheader}</Subheader>
            </>
          )
        }
      })}
        
      </ColumnLeft>

      <ColumnRight>
      <TabModuleContainer>
      {props.data.map(block=>{
              if(block.type==="tab"){
                return(
                  <CustomizedTab data={block["content"]}/>
                )
          }})}
      </TabModuleContainer>
      </ColumnRight>
    </Container>
  );

}

export default TheTippingPointTabs;